import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,MDBDataTable  } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip,PageHeader  } from 'antd';

import adminfaculty from '../adminfaculty/adminfaculty';
import Modalexpert from './Modalexpert';
import Modalexpertbn from './Modalexpertbn';
import Commentbnlist from './Commentbnlist';
import Commentbnlistfromex from './Commentbnlistfromex';

//import Modalarticletyps from './Modalarticletypes';+
import { URL,api } from '../../api';
import Modaladdexpert from '../superadmin/Modaladdexpert';
import Modalarticleaddexpert from '../superadmin/Modalarticleaddexpert';
import Commentbnlistbackexcheck from './Commentbnlistbackexcheck';
import Modalsentforgotpass from './Modalsentforgotpass';



export default class expertbnforgotpassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[],
            articleex:[],
            extertype:'',
            expert_id:'',
            url:'https://mua.kpru.ac.th/FrontEnd_Conferencekpru/',
            modal: false,
            registerall:[],
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
         this.selectex = this.selectex.bind(this);
         this.dow = this.dow.bind(this);
         this.extertype = this.extertype.bind(this);
         this.toggle = this.toggle.bind(this);
         
      }

     toggle = () => {
      this.setState({
        modal: !this.state.modal
      });
    }

    componentDidMount() {

      setTimeout(() => {
        
        api.get('registercon/selectforgotpassword' )
           .then(res => {
         //    console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
             this.setState({ expert_id: localStorage.getItem('iduser')})
           }) 

         }, 0);

         


      setTimeout(() => {
        api.get('registercon/selectregisterallpa' )
          .then(res => {
            console.log(res);
            this.setState({ registerall: res.data})
          }) 

         }, 0);

       
      //  this.extertype();
      }



      selectex() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
        }
        setTimeout(() => {
           
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpertatbn.php?idexpert='+localStorage.getItem('expert_id') )
           .then(res => {
          //   console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 

         }, 0);



      }

      extertype() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
        }
        setTimeout(() => {
           
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpertattype.php?idexpert='+localStorage.getItem('expert_id') )
           .then(res => {
          //   console.log(res.data[0].expert_type);
           //  this.setState({ bankname: res.data, loading: false })
        //     this.setState({ extertype: res.data[0].expert_type})
           }) 

         }, 0);



      }

      updateat(){
        setTimeout(() => {
           
          Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticle.php')
         .then(res => {
         //  console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }

      dow(){
       
           
          if (localStorage.getItem('expert_id') !== null) {

              if (this.state.extertype === '1') {
                 window.open(
                    'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/invite.php?expert_id='+localStorage.getItem('expert_id') ,
                    '_blank' // <- This is what makes it open in a new window.
                  );
              }else{
                window.open(
                  'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/invite2.php?expert_id='+localStorage.getItem('expert_id') ,
                  '_blank' // <- This is what makes it open in a new window.
                );

              }

           // window.location.href = 'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/invite.php?expert_id='+localStorage.getItem('expert_id') 
           

        } else {
        }
      }



    render() {
      console.log(this.state.expert_id)


      const datast = {
        columns: [
          {
            label: '#',
            field: 'list',
            sort: 'list',
            width: 150
          },
           {
            label: 'อีเมลล์',
            field: 'register_email',
            sort: 'register_email',
            width: 150
          },
          {
            label: 'รหัสผ่าน',
            field: 'coder',
            sort: 'coder',
            width: 150
          },
          {
            label: 'ชื่อ-นามสกุล',
            field: 'register_pname',
            sort: 'register_pname',
            width: 150
          },
          {
            label: 'เบอร์โทร',
            field: 'register_phone',
            sort: 'register_phone',
            width: 150
          },
         
      
        
        ],
  
  
        rows: [...this.state.registerall.map((data, i) => (
      
          {
     
  
             list: <>{i+1}</>,
             coder: <>{data.coder	}</>,
             register_email: <>{data.register_email	}</>,
             register_pname: <>{data.register_nameth	} {data.register_lnameth		}</>,
             register_phone: <>{data.register_phone		}</>,
            
          }
         ))]
    
        };
            const persons = <MDBDataTable
            // searching ={true}
            searchLabel="ค้นหา ชื่อ-นามสกุล"
            striped
            bordered
            small 
            entries={50}
            // entriesOptions={["10", "20"]}
            order={["age", "desc"]}
            data={datast}
            entriesLabel="จำนวนที่แสดง "
            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
            responsive 
            sortRows={['random']}
             theadColor="grey lighten-1"
            //  theadColor={"#ff4444"}
            />



        return (
            <MDBContainer fluid>
            <div>
            <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} (บรรณาธิการ)</p>
               {/* <MDBAlert color="success" >
                   <h2><MDBIcon icon="book-open" className="green-text pr-3" /> บทความเข้าใหม่</h2>
                </MDBAlert> */}
                <MDBAlert color="secondary" >
                                    <PageHeader
                                    className="site-page-header"
                                // onBack={() => null}
                                    title="รายการแจ้งลืมรหัสผ่าน"
                                    subTitle="รายการแจ้งลืมรหัสผ่าน"
                                    avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/4514/4514882.png' }}
                                />
                 </MDBAlert>    
                 <MDBBtn color="mdb-color" onClick={this.toggle} size='sm'>ข้อมูลผู้ลงทะเบียน</MDBBtn>
                <MDBTable bordered responsive small>
                    <MDBTableHead color="stylish-color" textWhite>
                        <tr>
                        <th>ลำดับ</th>
                        <th>email</th>
                        <th>เบอร์โทร</th>
                        <th>วันที่แจ้ง</th>
                        <th>การแจ้งกลับ</th>
                        {/* <th>ไฟล์บทความสำหรับตรวจ/อัพข้อเสนอแนะ</th> */}
                        {/* <th>สถานะ</th> */}
                        {/* <th>จัดการผู้ทรงคุณวุฒิ </th> */}
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.article.map((article,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{article.email_Forgot}</td>
                        <td>{article.tel_Forgot}</td>
                        <td>{article.date_Forgot}</td>
                        <td>
                          {article.status_Forgot === '2' ?<>
                            <MDBContainer><p>แจ้งกลับแล้ว</p>   </MDBContainer>
                          </>:<>
                           <Modalsentforgotpass id_Forgot={article.id_Forgot} email_Forgot={article.email_Forgot}/> 
                          </>}
                        </td>
                              {/* <td>
                           
                             </td> */}
                               
                         
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable>

                 <hr/>
                 <MDBModal isOpen={this.state.modal} toggle={this.toggle} fullHeight position="right" size="lg">
                    <MDBModalHeader toggle={this.toggle}>ข้อมูลผู้ลงทะเบียน</MDBModalHeader>
                    <MDBModalBody>
                      {persons}
                    </MDBModalBody>
                    <MDBModalFooter>
                      <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                      {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
                    </MDBModalFooter>
                 </MDBModal>

                {/* <MDBAlert color="success" >
                   <h2><MDBIcon icon="book-open" className="green-text pr-3" /> บทความหลังผู้ทรงตรวจ</h2>
                </MDBAlert>
                <MDBTable bordered>
                    <MDBTableHead color="stylish-color" textWhite>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความสำหรับตรวจ</th>
                       
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articleex.map((articleex,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articleex.send_name}</td>
                        <td>{articleex.major_precent}</td>
                        <td>
                            <Commentbnlistfromex id_send={articleex.id_send} expert_id={this.state.expert_id}  />
                             </td>
                         <td>
                             
                             </td>
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable> */}

            </div>
            </MDBContainer>
        )
    }
}
